import { gql } from '@ori/fetching';

import { labels } from './labels';

export const searchPreviewShade = gql`
  ${labels}
  fragment SearchPreviewShade on Product {
    shadeName
    hexColors
    colorImageUrl
    productCode
    formattedPrice {
      price {
        priceAfterImmediateDiscount
        currentPrice
      }
    }
    labels {
      ...ProductLabels
    }
  }
`;
